export const fbiaEnrichTag = (adTag: string, mediaid: string, playerType: string, pageOriginUrl: string) => {
  // similar to logic on indy site
  let customParams = '';
  let encodedCustomParams;
  customParams += 'videoID=' + mediaid;
  customParams += '&article=' + pageOriginUrl;
  customParams += '&playerType=' + playerType;

  // placeholder for adPos
  customParams += '&adpos=0';
  // default for playerstate
  customParams += '&playerstate=hero';
  encodedCustomParams = encodeURIComponent(customParams);

  const tagUrl = new URL(adTag);
  const urlParams = new URLSearchParams(tagUrl.search);
  if (urlParams.has('cust_params')) {
    if (urlParams.get('cust_params') !== '') {
      adTag = adTag.replace(/(cust_params[^&]+)/, '$1%26' + encodedCustomParams);
    } else {
      adTag = adTag.replace(/(cust_params[^&]+)/, '$1' + encodedCustomParams);
    }
  } else {
    adTag = adTag + '&cust_params=' + encodedCustomParams;
  }
  if (!urlParams.has('ad_rule')) {
    adTag = adTag + '&ad_rule=0'; // make sure tag contains 'ad_rule=0'
  }
  return adTag;
};
